import { useState } from "react"

import {
  isAValue,
  todayInISODate,
  valueFromPlainObject,
} from "web/services/helpers"
import { Button, Field, Form } from "web/components"
import { useModals } from "web/hooks/modals"

import { useTask } from "web/hooks/data"

import ViewDealButton from "./ViewDealButton"

const completeTaskFields = [
  {
    key: "comments",
    name: "comments",
    kind: "LegacyRichText",
    label: "Comments",
  },
  {
    key: "started_at",
    name: "started_at",
    kind: "Date",
    label: "Date Started",
  },
  {
    key: "completed_at",
    name: "completed_at",
    kind: "Date",
    label: "Date Completed",
  },
]

function CompleteTask({
  task: taskFromProps,
  respond,
  showDealContext = false,
  onWaitingChanged,
}) {
  const [task] = useTask(taskFromProps.id)

  const defaultCompletionDate = todayInISODate()

  const encodedTaskValue = valueFromPlainObject(
    {
      ...task,
      started_at: task.started_at || defaultCompletionDate,
      completed_at: defaultCompletionDate,
    },
    completeTaskFields
  )

  const [formValue, setFormValue] = useState(encodedTaskValue)

  async function handleToggleTaskComplete(formValue) {
    onWaitingChanged(true)

    const started_at =
      isAValue(formValue.started_at) && formValue.started_at.value

    const completed_at =
      isAValue(formValue.completed_at) && formValue.completed_at.value

    const comments = isAValue(formValue.comments)
      ? formValue.comments.value
      : null

    await task.update({
      started_at,
      completed_at,
      comments,
      status: "completed",
    })

    taskFromProps.refresh()

    respond()
  }

  return (
    <Form
      value={formValue}
      onChange={setFormValue}
      onSubmit={handleToggleTaskComplete}
      fields={completeTaskFields}
      render={(form) => {
        return (
          <div className="h-full">
            <div className="modal-content-above-commands">
              <div className="grid gap-y-5">
                <Field fieldKey="comments" />
                <Field fieldKey="started_at" />
                <Field fieldKey="completed_at" />
              </div>
            </div>
            <div className="modal-commands">
              <div className="left-buttons">
                {showDealContext && <ViewDealButton respond={respond} />}
              </div>
              <div className="right-buttons">
                <Button
                  disabled={!form.isValid}
                  onClick={form.submit}
                  testId="button-mark-task-complete"
                >
                  Mark Task Complete
                </Button>
              </div>
            </div>
          </div>
        )
      }}
    />
  )
}

export default function useCompleteTaskModal(showDealContext) {
  const { showModal } = useModals()

  return async function ({ task }) {
    return await showModal({
      title: `Complete Task: ${task.title}`,
      fullScreen: false,
      widthPixels: 800,
      message: "Saving changes. Please wait.",
      component: ({ respond, onWaitingChanged }) => (
        <CompleteTask
          task={task}
          respond={respond}
          showDealContext={showDealContext}
          onWaitingChanged={onWaitingChanged}
        />
      ),
    })
  }
}
